/**
 * @file index
 * @author Yu Zong(liuxuanzy@qq.com)
 */
export var OptionState;

(function (OptionState) {
  OptionState[OptionState["SELECTED"] = 2] = "SELECTED";
  OptionState[OptionState["UNSELECTED"] = 0] = "UNSELECTED";
})(OptionState || (OptionState = {}));